import { createFileRoute } from '@tanstack/react-router'
import { ComplianceOverview } from '@/features/compliance/overview'

export const Route = createFileRoute('/_authenticated/compliance/')({
  component: ComplianceOverview,
})
